export default __webpack_public_path__ + "static/media/TamarabadgeAR.14e8d5ac.jpg";